export enum CurrencyTypeEnum {
  USD = 'USD',
  EUR = 'EUR',
  COP = 'COP',
  MXN = 'MXN',
  ARS = 'ARS'
}
